import Vue from 'vue';
import previewScreenshot from "@/views/szrt_revision/teachingDetail/list/classroom/previewScreenshot";

let previewConstructor = Vue.extend(previewScreenshot);
const preview = new previewConstructor()
preview.$mount();
document.body.appendChild(preview.$el);
Vue.prototype.$showPreviewScreenshot = function (msg, ok) {
  return preview.show(msg, ok)
}
Vue.prototype.$showConfirm = function (msg, ok = () => {
}, cancel = () => {
}) {
  return this.$confirm(msg, '', {type: 'warning'}).then(ok).catch(cancel)
}
Vue.prototype.$showConfirmOfBtText = function (msg, [confirmButtonText, cancelButtonText] = ['确定', '取消'], ok = () => {
}, cancel = () => {
}) {
  return this.$confirm(msg, {confirmButtonText, cancelButtonText}).then(ok).catch(cancel)
}
Vue.prototype.$showAlert = function (msg, ok = () => {
}) {
  return this.$alert(msg, {
    confirmButtonText: '确定',
    callback: ok
  })
}
Vue.prototype.$showAlertOfBtText = function (msg, buttonText, ok = () => {
}) {
  return this.$alert(msg, {
    confirmButtonText: buttonText || '确定',
    callback: ok
  })
}
Vue.prototype.$BusEvent = new Vue()
Vue.prototype._$isInteger = function (value) {
  return /(^[+-]?\d+$)|(^[+-]?\d+\.\d+$)|(^\.\d+$)|(^\d+\.$)/.test(String(value))
}
/**
 * 正整数
 * @param obj
 * @param key
 * @private
 */
Vue.prototype._$toInteger = function (obj, key) {
  obj[key] = String(this._$isInteger(obj[key]) ? obj[key] : '')
    .replace(/\D+/, '')
    .replace(/^0{2,}/g, '0')
  if (obj[key].length > 1) {
    obj[key] = obj[key].replace(/^0+/g, '')
  }
}
/**
 * 正小数
 * @param obj
 * @param key
 * @param position
 * @private
 */
Vue.prototype._$toFloat = function (obj, key, position = 0) {
  obj[key] =
    String(this._$isInteger(obj[key]) ? obj[key] : '')
      .replace(/[^\d.]/g, '')
      .replace(/\.{2,}/g, '.')
      .replace('.', '$#$')
      .replace(/\.+/g, '')
      .replace('$#$', '.')
      .replace(new RegExp('^(\\-)*(\\d+)\\.(' + '\\d'.repeat(position) + ').*$'), '$1$2.$3')
      .replace(/^0{2,}/g, '0')
      .replace(/^\.+/g, '')
}

Vue.prototype._$toFloat1 = function (obj, key) {
  this._$toFloat(obj, key, 1)
}
Vue.prototype._$toFloat2 = function (obj, key) {
  this._$toFloat(obj, key, 2)
}
Vue.prototype._$toFloat3 = function (obj, key) {
  this._$toFloat(obj, key, 3)
}
Vue.prototype._$toFloat4 = function (obj, key) {
  this._$toFloat(obj, key, 4)
}

Vue.prototype._$toFixed = function (obj, key, num) {
  obj[key] = this._$isInteger(obj[key]) ? Number(obj[key]).toFixed(num) : ''
}
Vue.prototype._$toFixed2 = function (obj, key) {
  this._$toFixed(obj, key, 2)
}
Vue.prototype._$toFixed3 = function (obj, key) {
  this._$toFixed(obj, key, 3)
}
Vue.prototype._$toFixed4 = function (obj, key) {
  this._$toFixed(obj, key, 4)
}


Vue.prototype._$isNoEmpty = function (obj) {
  if (obj == null) {
    return false
  }
  if (this._$isInteger(obj)) {
    return true
  }
  if (typeof obj === 'string' && obj.replace(/\s+/g, '')) {
    return true
  }
  if ((obj instanceof Object) && Object.keys(obj).length) {
    return true
  }
  return Boolean(obj).valueOf()
}

/**
 * 例子 this._$arrayToMap([{id:1,name:'张三'},{id:2,name:'李四'},{id:3,name:'王五'}],id)
 * 得到 {1:{id:1,name:'张三'},2:{id:2,name:'李四'},3:{id:3,name:'王五'}}
 * @param array 数组
 * @param mapKey 作为key值使用
 * @returns {Promise<unknown>}
 * @private
 */
Vue.prototype._$arrayToMap = function (array, mapKey) {
  return new Promise((resolve, reject) => {
    try {
      const map = {};
      (Array.isArray(array) ? array : []).forEach(item => map[item[mapKey]] = item)
      resolve(map)
    } catch (e) {
      reject(e)
    }
  })
}
/**
 * @param response 接口的返回数据 object类型
 * @param map 数据处理方法
 * @returns {{}|*}
 * @private
 */
Vue.prototype._$handleResponse = function (response = {}, map = (object) => (object instanceof Object) ? object.data : object) {
  if (String(response['code']) === '0') {
    return map(response)
  } else {
    this.$messageError(response['msg'])
  }
  console.log('_$handleResponse:', response)
  return {}
}

/**
 *
 * @param format 'yyyy-mm-dd hh:mm:ss' | 'yyyy年mm月dd日 hh时mm分ss秒'
 * @returns {string}
 * @private
 */
Date.prototype._$formats = {
  en: 'yyyy-mm-dd hh:mm:ss',
  enAsDate: 'yyyy-mm-dd',
  zh: 'yyyy年mm月dd日 hh时mm分ss秒',
  zhAsDate: 'yyyy年mm月dd日',
}
Date.prototype._$formatDate = function (format = this._$formats.en, suffix = '') {
  const date = {
    yyyy: this.getFullYear(),
    mm: this.getMonth() + 1,
    dd: this.getDate()
  }
  const time = {
    hh: this.getHours(),
    mm: this.getMinutes(),
    ss: this.getSeconds()
  }
  const dates = [date, time]
  return format.split(/\s/).map((item, index) => item.replace(/(\w{4})|(\w{2})/g, key => String(dates[index][key]).padStart(2, '0'))).join(' ') + suffix
}
Date.prototype._$formatDateZh = function () {
  return this._$formatDate(this._$formats.zh)
}
Date.prototype._$formatDateEn = function () {
  return this._$formatDate(this._$formats.en)
}
// 封装同步获取获取网络时间方法
import Axios from 'axios';

Date.prototype._$getServerTime = function () {
  return Axios.get('/').then(res => res.headers.date ? new Date(res.headers.date) : new Date())
}
/**
 * @param currentDate 当前时间
 * @param year 要增加的年
 * @param month 要增加的月
 * @param day 要增加的天
 * @param hours 要增加的时
 * @param minutes 要增加的分
 * @param seconds 要增加的秒
 * @private
 */
Date.prototype._$skipTime = function (year, month, day, hours, minutes, seconds) {
  const getTime = (date) => date || 0
  return new Date(this.getFullYear() + getTime(year),
    this.getMonth() + getTime(month),
    this.getDate() + getTime(day),
    this.getHours() + getTime(hours),
    this.getMinutes() + getTime(minutes),
    this.getSeconds() + getTime(seconds))
}



// WEBPACK FOOTER //
// ./src/libs/ObjectPrototypes.js